function init() {

  const fakeSelectElements = Array.from(document.querySelectorAll('.fakeselect'));

  //loop all custom selectboxes
  if (fakeSelectElements) {
    fakeSelectElements.map((select) => {

      let fakeSelectIntro                         = select.querySelector('.fakeselect__intro');
      let fakeSelectIntroText                     = select.querySelector('.fakeselect__text');
      let fakeSelectDropdownElement               = select.querySelector('.fakeselect__dropdown');
      let fakeSelectDropdownElementOpenClassName  = 'fakeselect__dropdown--open';
      let fakeSelectActiveClassName               = 'fakeselect__intro--active';
      let fakeSelectChoice                        = select.querySelector('.fs-rb:checked');
      let fakeSelectFirstItem                     = select.querySelectorAll('.fs-rb')[0];
      let fakeSelectMultiname                     = select.classList.contains('fakeselect--multiname');

      // add event listener to dropdown fakeselect
      if (fakeSelectIntro && fakeSelectDropdownElement) {
        fakeSelectIntro.addEventListener('click', (e) => {
          e.preventDefault();
          changeDropdownState('open');
          document.addEventListener('click', fakeSelectOutsideClick);
        });

        // close dropdown when clicked outside
        const fakeSelectOutsideClick = function(e) {
          let isClickInside = fakeSelectDropdownElement.contains(e.target) || fakeSelectIntro.contains(e.target);
          if (!isClickInside) {
            changeDropdownState('close');
            document.removeEventListener('click', fakeSelectOutsideClick);
          }
        }
      }

      // see if a selection is made and show in intro
      if (fakeSelectIntroText && (fakeSelectChoice || fakeSelectFirstItem)) {
        let labelName = '';
        if (fakeSelectChoice) {
          labelName = getLabelNameOfRelatedInput(fakeSelectChoice);
          updateElementHTML(fakeSelectIntroText, labelName);
        } else {
          if (fakeSelectMultiname) {
            labelName = getLabelNameOfRelatedInput(fakeSelectChoice);
            updateElementHTML(fakeSelectIntroText, labelName);
          } else {
            labelName = getLabelNameOfRelatedInput(fakeSelectFirstItem);
            updateElementHTML(fakeSelectIntroText, labelName);
          }
        }
      }

      // update intro when selection is made and close dropdown
      if (fakeSelectDropdownElement) {
        let radiobuttons = Array.from(fakeSelectDropdownElement.querySelectorAll('.fs-rb'));
        let hasChecks = false;
        radiobuttons.map((radiobutton) => {
          radiobutton.addEventListener('change', (e) => {
            //remove active status from siblings in multiname mod e
            if (fakeSelectMultiname) {
              var selectionName      = radiobutton.getAttribute('name');
              var siblings           = Array.from(select.querySelectorAll(`.fs-rb:not([name="${selectionName}"])`));
              siblings.map((sibling) => {
                sibling.checked = false;
              });
            }

            let labelName = '';
            if (fakeSelectMultiname) {
              if (radiobutton.checked) {
                labelName = getLabelNameOfRelatedInput(radiobutton);
              } else {
                let fakeSelectIntroTextElement = select.querySelector('.fakeselect__text');
                let initIntroTextDataAttr = 'data-init-label';
                let hasInitIntroText = fakeSelectIntroTextElement.hasAttribute(initIntroTextDataAttr);
                labelName = (hasInitIntroText) ? fakeSelectIntroTextElement.getAttribute(initIntroTextDataAttr) : `${initIntroTextDataAttr} not defined`;
              }
            } else {
              labelName = getLabelNameOfRelatedInput(radiobutton);
            }
            updateElementHTML(fakeSelectIntroText, labelName);

            setTimeout(() => {
              changeDropdownState('close');
            }, 400);
          });
        });
      }

      function changeDropdownState(state) {
        switch (state) {
          case 'open':
            fakeSelectDropdownElement.classList.add(fakeSelectDropdownElementOpenClassName);
            fakeSelectIntro.classList.add(fakeSelectActiveClassName);
            fakeSelectDropdownElement.focus();
          break;

          case 'close':
            fakeSelectDropdownElement.classList.remove(fakeSelectDropdownElementOpenClassName);
            fakeSelectIntro.classList.remove(fakeSelectActiveClassName);
          break;
        }
      }

    });
  }

  function getLabelNameOfRelatedInput(input) {
    if (input) {
      let inputID = input.getAttribute('id');
      if (inputID) {
        return document.querySelector(`label[for="${inputID}"]`).innerHTML;
      }
    }
  }

  function updateElementHTML(selector, html) {
    if (selector && html) {
      selector.innerHTML = html;
    }
  }

}

export default init;



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Fakeselect.js